import React, {useCallback} from "react"
import {Button, Result} from "antd"
import {useNavigate} from "react-router-dom"

const ErrorAccessDenied = () => {
    const navigate = useNavigate()
    const onClickHandler = useCallback(() => navigate("/"), [navigate])

    return (
        <Result
            status="403"
            title="403"
            subTitle="У вас нет доступа"
            extra={
                <Button type="primary" onClick={onClickHandler}>
                    Назад на главную
                </Button>
            }
        />
    )
}

export default ErrorAccessDenied;